export const openPopup = (e) => {
  const targetImg = e.currentTarget.querySelector('img')
  document.querySelector('.overlay-img').src = targetImg.src
  gsap
    .timeline()
    .set('.overlay', {
      autoAlpha: 1,
    })
    .to('.overlay-bg', {
      duration: 0.4,
      ease: 'power3.out',
      opacity: 1,
      onComplete: () => {
        gsap.set('.overlay-bg', {
          willChange: 'auto',
        })
      },
    })
    .to(
      '.overlay-img',
      {
        duration: 0.3,
        ease: 'power4.out',
        opacity: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
      },
      0.25
    )
}

export const closePopup = () => {
  gsap.to('.overlay', {
    duration: 0.5,
    ease: 'power3.out',
    autoAlpha: 0,
    onComplete: () => {
      document.querySelector('.overlay-img').src = ''
      gsap.set('.overlay-bg', {
        opacity: 0,
        willChange: 'opacity',
      })
      gsap.set('.overlay-img', {
        opacity: 0,
        clipPath: 'inset(0% 100% 0% 0%)',
      })
    },
  })
}
